module.exports = __webpack_public_path__ + "static/media/more-active.02ae6b2a.svg";